import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { useTranslation } from 'react-i18next'
import DataApi from '../../../api/data/DataApi'
import { HttpError } from '../../../types/common'
import { showErrorToast } from '../../../utils/errors'
import { queryNames } from '../../queries'
import { mapDetailsDto } from '../../../mapping/locations'

const dataApi = DataApi.getInstance()

export default function useGetPlaceDetails(uuid: string, onError: (error: AxiosError<HttpError>) => void) {
  const texts = useTranslation().t

  const query = useQuery([queryNames.getPlaceDetails, uuid], async () => {
    const { data } = await dataApi.getPlaceDetails(uuid)
    return mapDetailsDto(data)
  }, {
    staleTime: Infinity,
    refetchOnMount: 'always',
    onError: (error: AxiosError<HttpError>) => {
      showErrorToast(error, texts)
      onError(error)
    }
  })

  return query
}
